<template>
  <div
    class="dark:bg-ontick-steel-500 bg-ontick-steel-300 relative flex h-5 w-full items-center justify-between overflow-hidden rounded px-2 text-xs"
    :class="active ? 'text-ontick-carbon-900 dark:text-white' : 'text-gray-400 dark:text-gray-500'"
  >
    <div class="bg-ontick-blue-600 absolute left-0 h-full transition-all" :style="`width: ${progress}%`"></div>
    <span class="z-10">
      {{ symbol }}
    </span>
    <span class="z-10 text-right">
      {{ volume }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    symbol: {
      type: String,
    },
    totalVolume: {
      type: Number,
    },
    currentVolume: {
      type: Number,
    },
    status: {
      type: String,
    },
    active: {
      type: Boolean,
    },
    volumeIsUndefined: {
      type: Boolean,
    },
  },

  computed: {
    progress() {
      if (this.volumeIsUndefined) {
        return 0;
      }
      return (this.currentVolume / this.totalVolume) * 100;
    },
    volume() {
      if (this.volumeIsUndefined) {
        return this.totalVolume;
      }
      return this.status === "Desligado" ? "-" : this.totalVolume;
    },
  },
};
</script>

<style></style>
